import React from 'react';
import { EnvelopeIcon, PhoneIcon } from '@heroicons/react/20/solid';
import { EnrichedLeadContact } from './enriched-leads-types';

interface EnrichedLeadContactRowProps {
  contact: EnrichedLeadContact;
}

export default function EnrichedLeadContactRow({ contact }: EnrichedLeadContactRowProps) {
  const fullName = [contact.title, contact.firstName, contact.lastName].filter(Boolean).join(' ');

  return (
    <div className="flex items-center justify-between py-2.5 px-4 hover:bg-neutral-25 rounded-md transition-colors">
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold text-neutral-800 truncate">
          {fullName}
        </p>
        {contact.jobTitle && (
          <p className="text-xs text-neutral-500 truncate">{contact.jobTitle}</p>
        )}
      </div>
      <div className="flex items-center gap-3 ml-4 shrink-0">
        {contact.email && (
          <a
            href={`mailto:${contact.email}`}
            className="flex items-center gap-1 text-xs text-main-600 hover:text-main-700 transition-colors"
            title={contact.email}
          >
            <EnvelopeIcon className="h-3.5 w-3.5" />
            <span className="hidden lg:inline max-w-[180px] truncate">{contact.email}</span>
          </a>
        )}
        {contact.phone && (
          <span className="flex items-center gap-1 text-xs text-neutral-600" title={contact.phone}>
            <PhoneIcon className="h-3.5 w-3.5" />
            <span className="hidden lg:inline">{contact.phone}</span>
          </span>
        )}
        {contact.linkedinUrl && (
          <a
            href={contact.linkedinUrl}
            target="_blank"
            rel="noreferrer"
            className="text-xs text-main-600 hover:text-main-700 transition-colors"
            title="LinkedIn"
          >
            <svg className="h-3.5 w-3.5" fill="currentColor" viewBox="0 0 24 24">
              <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
            </svg>
          </a>
        )}
      </div>
    </div>
  );
}
